(function () {
  const root = document.querySelector('[data-ga-collection]');
  if (!root) return;

  const viewButtons = root.querySelectorAll('[data-ga-collection-view]');
  const storageKey = 'ga-collection-view';
  const scopeKey = 'ga-collection-scope';
  const sizeParam = 'filter.v.option.Size';
  const colorParam = 'filter.v.option.Color';
  let redirectGuard = false;

  function getGrid() {
    return root.querySelector('[data-ga-collection-grid]');
  }

  function getScope() {
    const fromUrl = new URL(window.location.href).searchParams.get('scope');
    if (fromUrl === 'mens' || fromUrl === 'womens') return fromUrl;

    const fromRoot = root.dataset.gaCollectionScope;
    if (fromRoot === 'mens' || fromRoot === 'womens') return fromRoot;

    try {
      const stored = sessionStorage.getItem(scopeKey);
      if (stored === 'mens' || stored === 'womens') return stored;
    } catch {
      /* ignore */
    }

    return null;
  }

  function persistScope() {
    const scope = getScope();
    if (!scope) return;

    try {
      sessionStorage.setItem(scopeKey, scope);
    } catch {
      /* ignore */
    }

    const url = new URL(window.location.href);
    if (url.searchParams.get('scope') === scope) return;

    url.searchParams.set('scope', scope);
    history.replaceState(history.state, '', url.toString());
  }

  function setView(view) {
    const grid = getGrid();
    if (!grid) return;
    grid.setAttribute('data-view', view);
    viewButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.gaCollectionView === view);
      button.setAttribute('aria-pressed', button.dataset.gaCollectionView === view ? 'true' : 'false');
    });
    try {
      sessionStorage.setItem(storageKey, view);
    } catch {
      /* ignore */
    }
  }

  function needsOptionFilter() {
    const grid = getGrid();
    return grid?.dataset.gaNeedsOptionFilter === 'true';
  }

  function getOptionFilters() {
    const params = new URLSearchParams(window.location.search);
    return {
      sizes: params.getAll(sizeParam),
      colors: params.getAll(colorParam),
    };
  }

  function hasOptionFilters(filters) {
    return filters.sizes.length > 0 || filters.colors.length > 0;
  }

  function tokenize(value) {
    return (value || '')
      .split('|')
      .map((token) => token.trim())
      .filter(Boolean);
  }

  function matchesAny(selected, available) {
    if (!selected.length) return true;
    return selected.some((value) => available.includes(value));
  }

  function productMatchesOptions(options, filters) {
    const sizeOption = options.find((option) => option.name.toLowerCase() === 'size');
    const colorOption = options.find((option) => {
      const name = option.name.toLowerCase();
      return name === 'color' || name === 'colour';
    });

    const sizes = sizeOption?.values || [];
    const colors = colorOption?.values || [];

    return matchesAny(filters.sizes, sizes) && matchesAny(filters.colors, colors);
  }

  function productMatchesItem(item, filters) {
    const sizes = tokenize(item.dataset.gaOptionSizes);
    const colors = tokenize(item.dataset.gaOptionColors);
    return matchesAny(filters.sizes, sizes) && matchesAny(filters.colors, colors);
  }

  function productMatchesGender(item) {
    const scope = getScope();
    if (!scope) return true;

    const gender = (item.dataset.gaProductGender || 'unknown').toLowerCase();
    if (gender === scope) return true;
    if (gender === 'unknown') return false;
    return false;
  }

  function applyGenderFilter() {
    const scope = getScope();
    if (!scope) return;

    const grid = getGrid();
    if (!grid) return;

    grid.querySelectorAll('.ga-collection__item').forEach((item) => {
      if (!productMatchesGender(item)) {
        item.hidden = true;
      }
    });
  }

  function syncFilterInputs(filters) {
    root.querySelectorAll(`input[name="${sizeParam}"], input[name="${colorParam}"]`).forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const selected = input.name === sizeParam ? filters.sizes : filters.colors;
      input.checked = selected.includes(input.value);
    });
  }

  function updateResultsCount(visibleCount, totalCount) {
    const range = root.querySelector('.ga-collection__range');
    if (!range) return;

    if (totalCount === 0) {
      range.textContent = 'Showing 0 results';
      return;
    }

    if (visibleCount === totalCount) {
      range.textContent = `Showing 1–${totalCount} of ${totalCount} results`;
      return;
    }

    range.textContent = `Showing ${visibleCount} of ${totalCount} results on this page`;
  }

  function toggleEmptyState(visibleCount, totalCount) {
    const results = root.querySelector('.ga-collection__results');
    if (!results) return;

    let emptyState = results.querySelector('.ga-collection__empty--filtered');
    if (visibleCount > 0 || totalCount > 0) {
      emptyState?.remove();
      const grid = getGrid();
      if (grid) grid.hidden = false;
      return;
    }

    const grid = getGrid();
    if (grid) grid.hidden = true;
    if (emptyState) return;

    emptyState = document.createElement('div');
    emptyState.className = 'ga-collection__empty ga-collection__empty--filtered';
    emptyState.innerHTML =
      '<h2>No products found</h2><p>Try removing filters or <a class="ga-collection__empty-link" href="' +
      window.location.pathname +
      '">clear all filters</a>.</p>';
    results.appendChild(emptyState);
  }

  async function fetchAllProducts() {
    const collectionPath = window.location.pathname;
    const sortBy = new URL(window.location.href).searchParams.get('sort_by') || 'best-selling';
    const products = [];
    let page = 1;

    while (page <= 20) {
      const params = new URLSearchParams({ limit: '250', page: String(page) });
      if (sortBy) params.set('sort_by', sortBy);

      const response = await fetch(`${collectionPath}/products.json?${params.toString()}`);
      if (!response.ok) break;

      const data = await response.json();
      if (!Array.isArray(data.products) || data.products.length === 0) break;

      products.push(...data.products);
      if (data.products.length < 250) break;
      page += 1;
    }

    return products;
  }

  function getProductsPerPage() {
    const grid = getGrid();
    const items = grid ? [...grid.querySelectorAll('.ga-collection__item')] : [];
    if (items.length > 0) return items.length;

    return 12;
  }

  function getPageForProductIndex(index, perPage) {
    return Math.floor(index / perPage) + 1;
  }

  function buildFilteredUrl(filters, page) {
    const url = new URL(window.location.href);
    url.searchParams.delete(sizeParam);
    url.searchParams.delete(colorParam);
    url.searchParams.delete('page');

    filters.sizes.forEach((value) => url.searchParams.append(sizeParam, value));
    filters.colors.forEach((value) => url.searchParams.append(colorParam, value));

    if (page > 1) url.searchParams.set('page', String(page));

    return url.toString();
  }

  async function applyOptionFilters() {
    if (!needsOptionFilter()) return;

    const grid = getGrid();
    if (!grid) return;

    const filters = getOptionFilters();
    syncFilterInputs(filters);

    if (!hasOptionFilters(filters)) {
      grid.querySelectorAll('.ga-collection__item').forEach((item) => {
        item.hidden = false;
      });
      root.querySelector('.ga-collection__empty--filtered')?.remove();
      grid.hidden = false;
      return;
    }

    const items = [...grid.querySelectorAll('.ga-collection__item')];
    let visibleCount = 0;

    items.forEach((item) => {
      const show = productMatchesItem(item, filters);
      item.hidden = !show;
      if (show) visibleCount += 1;
    });

    let totalMatches = visibleCount;

    try {
      const allProducts = await fetchAllProducts();
      const matchingProducts = allProducts.filter((product) => productMatchesOptions(product.options, filters));
      totalMatches = matchingProducts.length;

      if (!redirectGuard && visibleCount === 0 && totalMatches > 0) {
        const perPage = getProductsPerPage();
        const firstIndex = allProducts.findIndex((product) => productMatchesOptions(product.options, filters));

        if (firstIndex >= 0) {
          const targetPage = getPageForProductIndex(firstIndex, perPage);
          const currentPage = Number(new URL(window.location.href).searchParams.get('page') || '1');

          if (targetPage !== currentPage) {
            redirectGuard = true;
            window.location.assign(buildFilteredUrl(filters, targetPage));
            return;
          }
        }
      }
    } catch {
      totalMatches = visibleCount;
    }

    updateResultsCount(visibleCount, totalMatches);
    toggleEmptyState(visibleCount, totalMatches);
  }

  function scheduleOptionFilters() {
    window.requestAnimationFrame(() => {
      window.setTimeout(() => {
        applyOptionFilters();
      }, 60);
    });
  }

  const storedView = (() => {
    try {
      return sessionStorage.getItem(storageKey);
    } catch {
      return null;
    }
  })();

  if (storedView === 'grid' || storedView === 'list') {
    setView(storedView);
  }

  viewButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setView(button.dataset.gaCollectionView || 'grid');
    });
  });

  persistScope();
  applyGenderFilter();
  scheduleOptionFilters();

  document.addEventListener('filter:update', () => {
    redirectGuard = false;
    persistScope();
    applyGenderFilter();
    scheduleOptionFilters();
  });

  window.addEventListener('popstate', scheduleOptionFilters);
})();
